export const BROADCAST_AUDIO_MODE_RAW = "raw";

export const BROADCAST_AUDIO_MODES = [
  { id: BROADCAST_AUDIO_MODE_RAW, label: "RAW", detail: "No sound suppression" },
];

export const normalizeBroadcastAudioMode = () => BROADCAST_AUDIO_MODE_RAW;

export const getBroadcastAudioCaptureOptions = () => ({
  channelCount: 2,
  sampleRate: 48_000,
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: false,
  voiceIsolation: false,
});

export const getBroadcastAudioPublishOptions = () => ({
  audioPreset: { maxBitrate: 192_000, priority: "high" },
  forceStereo: true,
  dtx: false,
  red: true,
});

// Viewer call-ins are speech, not the creator's RAW concert/program feed.
// Mobile voice processing raises quiet handset microphones and prevents the
// creator's audio from feeding back through the viewer's speaker.
export const getAudienceAudioCaptureOptions = () => ({
  channelCount: 1,
  sampleRate: 48_000,
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
  voiceIsolation: false,
});

export const getAudienceAudioPublishOptions = () => ({
  audioPreset: { maxBitrate: 96_000, priority: "high" },
  forceStereo: false,
  dtx: false,
  red: true,
});

// AWS IVS low-latency channels accept at most 1080p / 8.5 Mbps. `max` is
// therefore a real 1080p60 ceiling, not a misleading 4K setting.
const VIDEO_ENCODINGS = {
  max: { maxBitrate: 8_500_000, maxFramerate: 60, priority: "high" },
  "4k": { maxBitrate: 8_500_000, maxFramerate: 60, priority: "high" },
  "1080p": { maxBitrate: 6_000_000, maxFramerate: 30, priority: "high" },
  "720p": { maxBitrate: 3_400_000, maxFramerate: 30, priority: "high" },
  "360p": { maxBitrate: 800_000, maxFramerate: 30, priority: "high" },
  auto: { maxBitrate: 6_000_000, maxFramerate: 30, priority: "high" },
};

export const getBroadcastVideoEncoding = (quality = "auto") => ({
  ...(VIDEO_ENCODINGS[quality] || VIDEO_ENCODINGS.auto),
});

export const calculateVideoBitrateKbps = (previous, current, elapsedMs) => {
  const duration = Number(elapsedMs || 0);
  const byteDelta = Number(current?.bytesSent || 0) - Number(previous?.bytesSent || 0);
  if (duration <= 0 || byteDelta < 0) return 0;
  return Math.round((byteDelta * 8) / duration);
};
